<template>
  <div class="dialog-viewer-picture" :class="{ 'android-padding': isAndroid, 'ios-padding': isIOS }">
    <header>
      <div class="name">
        {{ resource.name }}
      </div>
      <ViewerAppTip />
      <span class="xlpfont xlp-cross" @click="$emit('close'), clickStat('close')" />
    </header>
    <div class="viewer-inner">
      <span
        class="xlpfont xlp-btn-pic-pre" :class="{ hidden: index === 0 || index === -1 }"
        @click="onPre"
      />
      <span class="xlp-play-loading__icon" v-show="!show" />
      <TdViewerImage
        :src="imgSrc" :visible="show"
        @stat="clickStat"
      />
      <span
        class="xlpfont xlp-btn-pic-next" :class="{ hidden: index === list.length - 1 || index === -1 }"
        @click="onNext"
      />
    </div>
  </div>
</template>
<script>

import { useStore } from 'vuex'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { useHeziFileStore, getFileInfoToPreview } from '@remote/store/hezi-file'
import { useBTResult } from '@remote/store/hezi-file/bt-result'
import { isImageFile } from '@remote/utils/file-helper'
import ViewerAppTip from './ViewerAppTip'
import TdViewerImage from './TdViewerImage'

export default {
  components: {
    ViewerAppTip,
    TdViewerImage,
  },
  props: {
    id: {
      type: String,
      default: '0',
    },
    previewFileInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  setup () {
    const store = useStore()
    const { data } = useHeziFileStore()
    const { data: btResultData } = useBTResult()
    if (btResultData.visible) {
      const list = []
      const all = {}
      for (let v of Object.values(btResultData.all)) {
        all[v.md5sum] = v
        list.push(v.md5sum)
      }
      return { store, all: all, home: { list: list }, isAndroid, isIOS }
    } else {
      return { store, all: data.all, home: { list: data.files }, isAndroid, isIOS }
    }
  },
  data () {
    return {
      qrcode: require('@remote/assets/images/web/qrcode.png'),
      index: 0,
      pid: '',
      show: false,
      isFirst: true,
      fallbackResource: null,
    }
  },
  computed: {
    list () {
      const newList = this.home.list
      const all = this.all
      return newList
        .filter(v => isImageFile(all[v].name))
        .filter(v => {
          if (all[v].audit) {
            if (all[v].audit.status === 'STATUS_OK') return v
          } else {
            return v
          }
        })
    },
    resource () {
      return this.all[this.pid] || {}
    },
    imgSrc () {
      return this.resource?.web_content_link || this.fallbackResource?.web_content_link || this.previewFileInfo?.web_content_link
    },
    isInSafebox () {
      return this.store.state.safebox.isIn
    },
  },
  watch: {
    imgSrc: {
      async handler (val) {
        if (!val) throw 'web_content_link not exit'
        this.width = 0
        this.scale = 1
        this.rotate = 0
        const img = new Image()
        img.onload = async () => {
          this.show = true
        }
        img.src = val
        this.show = img.complete
      },
      immediate: true,
    },
  },
  created () {
    this.index = this.list.indexOf(this.id)
    this.load()
    this.$stat('pc_yunpan_web', 'yunpan_web_photo_browser_show')
  },
  methods: {
    onPre () {
      this.show = false
      this.fallbackResource = null
      if (this.index >= 1) {
        this.index -= 1
      } else {
        this.index = this.list.length - 1
      }
      this.clickStat('prev')
      this.load()
    },
    onNext () {
      this.show = false
      this.fallbackResource = null
      if (this.index >= this.list.length - 1) {
        this.index = 0
      } else {
        this.index += 1
      }
      this.clickStat('next')
      this.load()
    },
    load () {
      this.pid = this.list[this.index]
      if (!this.pid) {
        if (!this.list.length && this.previewFileInfo.web_content_link) {
          this.fallbackResource = this.previewFileInfo
        } else {
          // return this.$emit('close')
        }
      }
      if (!this.all[this.pid]?.web_content_link) {
        if (this.resource.md5sum) {
          getFileInfoToPreview(this.resource)
            .then(res => {
              if (res) this.fallbackResource = res
            })
        }
      }
    },
    clickStat (clickid) {
      this.$stat('pc_yunpan_web', 'yunpan_web_photo_browser_click', { clickid })
    },
  },
}
</script>

<style lang="scss">
/* scrollbar */
@mixin scrollbar ($width, $radius, $background-thumb, $background-thumb-hover) {
  &::-webkit-scrollbar {
    width: $width;
    background: transparent;

    &:horizontal {
      height: $width;
    }

    &-thumb {
      border-radius: $radius;
      width: $width;
      background: $background-thumb;

      &:hover {
        background: $background-thumb-hover;
      }
    }
  }
}

@mixin scrollbarNormal () {
  &::-webkit-scrollbar {
    width: 6px;
    background: transparent;

    &:horizontal {
      height: 6px;
    }

    &-thumb {
      border-radius: 2px;
      width: 6px;
      background: var(--color-border), ;

      &:hover {
        background: #ccc;
      }
    }
  }
}

/* BEM */
@mixin b($block) {
  $B: $namespace+'-'+$block !global;

  .#{$B} {
    @content;
  }
}

@mixin e($element) {
  $selector: &;
  $currentSelector: "";

  @each $unit in $element {
    $currentSelector: #{$currentSelector + "." + $B + $element-separator + $unit + ","};
  }

  @at-root {
    #{$currentSelector} {
      @content;
    }
  }
}

@mixin m($modifier) {
  $selector: &;
  $currentSelector: "";

  @each $unit in $modifier {
    $currentSelector: #{$currentSelector + & + $modifier-separator + $unit + ","};
  }

  @at-root {
    #{$currentSelector} {
      @content;
    }
  }
}

@mixin when($state) {
  @at-root {
    &.#{$state-prefix + $state} {
      @content;
    }
  }
}

@mixin middle() {
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin arrow($width1, $width2, $color, $pos) {
  position: absolute;
  width: 0;
  height: 0;
  font-size: 0;
  overflow: hidden;
  border-style: dashed;
  border-color: transparent;
  border-width: $width1 $width2;
  border-#{$pos}-color: $color;
  content: '';
}


@mixin bgGradient($deg, $start, $end) {
  background-image: linear-gradient($deg, $start, $end);
}

@mixin cover($opacity) {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, $opacity);
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin line($num) {
  @if($num==1) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  @else {
    -webkit-line-clamp: $num;
    display: -webkit-box;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

}


.dialog-viewer-picture {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: column;

  &.android-padding {
    padding: 22px 15px 0;
  }

  &.ios-padding {
    padding: 40px 15px 0;
  }

  header {
    background: #000;
    color: #fff;
    width: 100%;
    height: 60PX;
    display: flex;
    align-items: center;
    font-size: 13PX;
    z-index: 1000;
    flex-shrink: 0;

    .name {
      margin-left: 18PX;
    }

    .xlp-cross {
      margin: 0 18PX 0 63PX;
      color: #d5d9de;
      font-size: 14PX;
      cursor: pointer;
    }

    @media screen and (min-width: 1100px) {
      .name {
        display: inline-block;
      }
    }

    @media screen and (max-width: 760px) {
      .name {
        display: none;
      }

      .viewer-app-tip {
        flex: 1;
        margin-left: 95PX;
        text-align: center;
      }
    }
  }

  .viewer-inner {
    display: flex;
    justify-content: center;
    justify-self: center;
    align-items: center;
    flex: 1;
    max-height: calc(100% - 60PX);

    .td-viewer {
      position: relative;
      display: flex;
      flex-direction: column;
      background: transparent;
      width: 100%;
      height: 100%;

      img {

        // TODO: 需要要移动时更改
        &:hover {
          cursor: grab;
        }

        // cursor: grabbing;
      }

      &__header {
        display: none;
      }

      &__body {
        flex: 1;
        overflow: auto;
        overscroll-behavior: contain;

        img {
          position: absolute;
          width: 100%;
          height: 95%;
          display: block;
          margin: 0 auto;
          object-fit: contain;
        }
      }

      &__footer {
        z-index: 9;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50PX;
        background: #000;

        a {
          cursor: pointer;
          margin: 0 12px;

          i {
            font-size: 24PX;
            color: #fff;
          }
        }

        .td-icon-download {
          display: none;
        }
      }
    }

    .xlpfont {
      color: #fff;
      font-size: 30PX;
      cursor: pointer;
      position: absolute;
      z-index: 1000;

      &:hover {
        background: #000000;
        border-radius: 4PX;
      }

      &.hidden {
        visibility: hidden;
      }
    }

    .xlp-btn-pic-pre {
      margin-left: 45PX;
      margin-right: auto;
      left: 0px;
    }

    .xlp-btn-pic-next {
      margin-right: 45PX;
      margin-left: auto;
      right: 0;
    }

    .xlp-play-loading__icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80PX;
      height: 80PX;
      margin-left: -40PX;
      margin-top: -40PX;
      z-index: 1;
    }
  }
}
</style>
